// default locality selection of the pages with a locality filter
export const DEFAULT_LOCALITY_IDS = ["68a2f0f02334c6e80d89b03d"];
